import { render, staticRenderFns } from "./ProdutoTab.vue?vue&type=template&id=294b5ad4&scoped=true"
import script from "./ProdutoTab.vue?vue&type=script&lang=js"
export * from "./ProdutoTab.vue?vue&type=script&lang=js"
import style0 from "./ProdutoTab.vue?vue&type=style&index=0&id=294b5ad4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294b5ad4",
  null
  
)

export default component.exports